const protocol = window.location.protocol;
const hostname = window.location.hostname;
const port = window.location.port ? `:${window.location.port}` : "";

export const WEB_DOMAIN = `${protocol}//${hostname}${port}`;
export const REST_SERVER = "https://api-newdev.fundedhere.com";

